var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KioskAuthLayout",
    {
      attrs: {
        "is-new": false,
        "next-disabled": _vm.$v.name.$invalid,
        "show-next-button": "",
        "show-back-button": "",
        title: "Your name"
      },
      on: { back: _vm.handleBack, next: _vm.handleNext }
    },
    [
      _c("div", { class: _vm.$style.authForm }, [
        _c("p", { class: _vm.$style.authFormText }, [
          _vm._v(
            "\n      Please enter your first name and last name initial\n    "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.$style.authField },
          [
            _c("InputField", {
              class: [
                _vm.$style.authInput,
                ((_obj = {}),
                (_obj[_vm.$style.authInputError] = _vm.$v.name.$error),
                _obj)
              ],
              attrs: { type: "text" },
              model: {
                value: _vm.$v.name.$model,
                callback: function($$v) {
                  _vm.$set(_vm.$v.name, "$model", $$v)
                },
                expression: "$v.name.$model"
              }
            }),
            _vm._v(" "),
            _vm.$v.name.$error
              ? _c("p", { class: _vm.$style.errorMessage }, [
                  _vm._v("\n        Name is required\n      ")
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.$style.touchKeyboard },
          [
            _c("Keyboard", {
              model: {
                value: _vm.$v.name.$model,
                callback: function($$v) {
                  _vm.$set(_vm.$v.name, "$model", $$v)
                },
                expression: "$v.name.$model"
              }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/kiosk/components/KioskAuthForm.vue?vue&type=template&id=1685edd4&
// module id = null
// module chunks = 